import { IRoutePointDto } from "@shared/services/orders/dtos/orders/routePointDto";

export const getPickupTime = (rp: IRoutePointDto) => rp.orderTime;

export const getDropOffTime = (rp: IRoutePointDto) => rp.orderTime;
